import { render, staticRenderFns } from "./CallForFunds.vue?vue&type=template&id=2bb7c46b&"
import script from "./CallForFunds.vue?vue&type=script&lang=js&"
export * from "./CallForFunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports